/**
 * Type declarations for the Icon component variants.
 */
import { stringLiteralArray } from "../utils"

export type Size = typeof sizes[number]
export type Icon = typeof icons[number]

export type ThemeProps = {
  sizing: Record<Size, number>
}

const sizes = stringLiteralArray(["xs", "sm", "md", "lg", "xl"])
const icons = stringLiteralArray([
  "Album",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "Ban",
  "Bell",
  "Bold",
  "Bolt",
  "Bookmark",
  "Calendar",
  "Camera",
  "Cart",
  "Check",
  "CheckCircle",
  "ChevronDown",
  "ChevronLeft",
  "ChevronRight",
  "ChevronUp",
  "Circle",
  "Clock",
  "Close",
  "CloseCircle",
  "CloudDownload",
  "CloudUpload",
  "Code",
  "Cog",
  "Comment",
  "Commenting",
  "Comments",
  "Copy",
  "CreateCloudShell",
  "CreditCard",
  "Database",
  "Desktop",
  "Download",
  "Expand",
  "EyeClosed",
  "ExternalLink",
  "EyeOpen",
  "File",
  "FileEdit",
  "Filter",
  "Folder",
  "Forward",
  "Future",
  "GitBranch",
  "GitFork",
  "Grid",
  "Happy",
  "Hashtag",
  "Heart",
  "History",
  "Home",
  "Image",
  "Info",
  "Italic",
  "Laptop",
  "Lifesaver",
  "Link",
  "List",
  "Location",
  "Lock",
  "Mail",
  "Menu",
  "Minimize",
  "Minus",
  "MinusCircle",
  "More",
  "MoreVertical",
  "Move",
  "Nut",
  "PaintBucket",
  "Pencil",
  "Phone",
  "PhoneLandscape",
  "Play",
  "PlayCircle",
  "Plus",
  "PlusCircle",
  "Pull",
  "Push",
  "Question",
  "QuoteRight",
  "Receiver",
  "Refresh",
  "Reply",
  "RestartCloudShell",
  "Rss",
  "Search",
  "Server",
  "Settings",
  "Shrink",
  "SignIn",
  "SignOut",
  "Social",
  "Star",
  "Strikethrough",
  "Table",
  "Tablet",
  "TabletLandscape",
  "Tag",
  "Thumbnails",
  "TopmenuCloudShell",
  "Trash",
  "TriangleDown",
  "TriangleLeft",
  "TriangleRight",
  "TriangleUp",
  "Tv",
  "Unlock",
  "Upload",
  "User",
  "Users",
  "VideoCamera",
  "Warning",
  "World",
  "Xing"
])

const enumerableProps = {
  sizes,
  icons
}

export { enumerableProps }
